<template>
  <el-container>
    <div class="g-aside-main">
      <el-form :inline="true" @submit.native.prevent>
        <el-row type="flex">
          <el-col style="text-align: left">
            <el-button @click="goBack"> 返回 </el-button>
          </el-col>
          <el-col style="text-align: right">
            <el-form-item label="选择考试">
              <ksList
                :value.sync="ksObj"
                :ksid.sync="ksid"
                @change="query()"
              ></ksList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-bottom: 20px" v-if="ksObj">
          <el-col :span="6"> 考试名称：{{ ksObj.ksmc }} </el-col>
          <el-col :span="6"> 考试时间：{{ ksObj.djsj }} 分钟 </el-col>
          <el-col :span="6"> 试卷总分：{{ ksObj.zf }} 分 </el-col>
          <el-col :span="6"> 及格分： {{ ksObj.jgfs }} 分 </el-col>
        </el-row>
      </el-form>
      <el-row style="margin-bottom: 10px">
        <el-col> 成绩概况： </el-col>
        <el-col style="text-align: right; padding-bottom: 5px">
          <el-button
            type="primary"
            style="color: white"
            @click="exportExamAnalysisExcel"
          >
            导出考试分析结果
          </el-button>
        </el-col>
      </el-row>
      <div class="yun-shadow">
        <el-table :data="tableData" style="width: 100%" :border="true">
          <el-table-column
            label="总分"
            width="120"
            prop="sjzf"
            align="center"
          />
          <el-table-column
            label="参考次数"
            width="80"
            prop="ckcs"
            align="center"
          />
          <el-table-column
            label="未考人数"
            width="100"
            prop="wkrs"
            align="center"
          >
            <template slot-scope="scope">
              <a href="#" @click="showWkDialog()" style="color: blue">{{
                scope.row.wkrs
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            label="最低分"
            width="80"
            prop="zdfs"
            align="center"
          />
          <el-table-column
            label="平均分"
            width="80"
            prop="pjfs"
            align="center"
          />
          <el-table-column
            label="最高分"
            width="80"
            prop="zgfs"
            align="center"
          />
          <el-table-column
            label="及格分(占总分60%)"
            width="150"
            prop="jgfs"
            align="center"
          />
          <el-table-column
            label="及格次数"
            width="80"
            prop="jgcs"
            align="center"
          />
          <el-table-column
            label="及格率(%)"
            width="80"
            prop="jgl"
            align="center"
          />
          <el-table-column
            label="平均时长"
            width="100"
            prop="pjsc"
            align="center"
          />
        </el-table>
        <el-dialog
          title="未考考生列表"
          :visible.sync="showDialogWk"
          width="55%"
          :modal-append-to-body="false"
        >
          <el-row
            style="padding: 10px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)"
          >
            考试名称：{{ ksObj.ksmc }}
            <el-table :data="tableDataWk" :border="true">
              <el-table-column label="考生姓名" width="260" prop="ksxm" />
              <el-table-column label="部门" width="305" prop="bm" />
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
            >
            </el-pagination>
          </el-row>
        </el-dialog>
      </div>
      <el-row>
        <el-col style="text-align: right; margin-top: 20px; margin-bottom: 1px">
          <el-button @click="showDialogFdsz = true">分段设置</el-button>
        </el-col>
        <el-col>
          <el-dialog
            :visible.sync="showDialogFdsz"
            :close-on-click-modal="false"
            :modal-append-to-body="false"
          >
            <el-steps :active="active" finish-status="success">
              <el-step
                :title="item + '分'"
                v-for="(item, index) in numScore"
                :key="index"
                @click.native="delScore(index)"
              >
              </el-step>
            </el-steps>
            <br />
            <el-input
              style="width: 200px; margin-right: 10px"
              v-model="score"
              autocomplete="off"
              placeholder="请输入分数 例如 ：40"
              onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'');value=value==''?null:value;"
              @keyup.enter.native="addSroce()"
            ></el-input>
            <el-button type="primary" @click="addSroce()">添加</el-button>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showDialogFdsz = false">取 消</el-button>
              <el-button type="primary" @click="viewFdsz()">确 定</el-button>
            </div>
          </el-dialog>
        </el-col>
        <el-col style="background-color: #e8e7e7; padding: 5px">
          <el-row style="margin-bottom: 10px"> 成绩概况 </el-row>
          <el-row>
            <el-button @click="changeType(0)">饼图</el-button>
            <el-button @click="changeType(1)">柱状图</el-button>
            <el-button @click="changeType(2)">条形图</el-button>
            <el-button @click="changeType(3)">折线图</el-button>
            <ve-chart
              :data="chartData"
              :settings="chartSettings"
              style="padding-left: 10%; width: 70%; text-align: center"
            ></ve-chart>
          </el-row>
        </el-col>
      </el-row>
      <div class="yun-shadow" style="display: flex">
        <div style="width: calc(50% - 15px)">
          <el-table :data="tableDataQ" style="width: 100%" :border="true">
            <el-table-column label="考生" width="115" prop="ksxm" />
            <el-table-column label="部门" width="180" prop="bm" />
            <el-table-column label="分数" width="60" prop="fs" align="center" />
            <el-table-column label="排名" width="60" prop="pm" align="center" />
          </el-table>
        </div>
        <div style="width: 30px"></div>
        <div style="width: calc(50% - 15px)">
          <el-table :data="tableDataH" style="width: 100%" :border="true">
            <el-table-column label="考生" width="115" prop="ksxm" />
            <el-table-column label="部门" width="180" prop="bm" />
            <el-table-column label="分数" width="60" prop="fs" align="center" />
            <el-table-column label="排名" width="60" prop="pm" align="center" />
          </el-table>
        </div>
      </div>
    </div>
  </el-container>
</template>
<script>
import * as report from '@/api/report'
import ksList from '@/components/select/ksList'
import { baseURL } from '@/assets/js/config'
import VCharts from 'v-charts'
import Vue from 'vue'
Vue.use(VCharts)
export default {
  data () {
    return {
      ksid: Number(this.$route.query.ksid),
      ksObj: {},
      showDialogFdsz: false,
      showDialogWk: false,
      typeArr: ['pie', 'histogram', 'bar', 'line'],
      numScore: [],
      score: '',
      chartData: {
        columns: ['fd', '人数'],
        rows: []
      },
      chartSettings: {},
      active: 50,
      tableData: [],
      tableDataQ: [],
      tableDataH: [],
      tableDataAll: [],
      js: 0,
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableDataWk: []
    }
  },
  components: {
    ksList
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/exam/list'
      })
    },
    exportExamAnalysisExcel () {
      const params = 'ksid=' + this.ksObj.ksid
      const ksname = this.ksObj.ksmc
      // 后台数据下载不能用ajqx请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open(
        'GET',
        baseURL + '/report/exportExamAnalysisExcel?' + params,
        true
      )
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求陈宫返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          const filename = ksname + '考试分析结果.xls'
          const a = document.createElement('a')
          // 创键临时url对象
          const url = URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url)
        }
      }
      xmlhttp.send()
    },
    showWkDialog (currentPage = 1) {
      this.showDialogWk = true
      this.currentPage = currentPage
      const params = Object.assign(
        { pageNo: this.currentPage, pageSize: this.pageSize },
        {}
      )
      params.ksid = this.ksObj.ksid
      report.getWkList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableDataWk = data.list
          this.totalNum = data.count
        })
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.showWkDialog(this.currentPage)
    },
    handleCurrentChange (val) {
      this.showWkDialog(val)
    },
    viewFdsz () {
      this.showDialogFdsz = false
      this.getnumScore()
    },
    getnumScore () {
      const xx = this.numScore
      this.chartData.rows = []
      this.numScore.forEach((item, index) => {
        if (index + 1 !== xx.length) {
          if (xx[index + 1] !== this.ksObj.zf) {
            this.chartData.rows.push({
              fd: '[' + item + ',' + xx[index + 1] + ')',
              人数: this.getNum(item, xx[index + 1])
            })
          } else {
            this.chartData.rows.push({
              fd: '[' + item + ',' + xx[index + 1] + ']',
              人数: this.getNum(item, xx[index + 1] + 1)
            })
          }
        }
      })
    },
    getNum (a, b) {
      this.js = 0
      this.tableDataAll.forEach((item, index) => {
        if (a <= item.fs && item.fs < b) {
          this.js++
        }
      })
      return this.js
    },
    delScore (index) {
      this.numScore.splice(index, 1)
    },
    addSroce () {
      if (this.score && this.score !== '') {
        if (
          this.score <= 0 ||
          this.score >= this.ksObj.zf ||
          this.numScore.indexOf(this.score) > -1
        ) {
          this.score = ''
        } else {
          this.numScore.push(this.score)
          this.numScore.sort((a, b) => a - b)
          this.score = ''
        }
      }
    },
    // 查询考试成绩概况
    query () {
      const params = {}
      params.ksid = this.ksObj.ksid
      report.ksfxPage(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data[0].ksList
          this.tableDataAll = data[0].bmpmList
          this.tableDataQ = data[0].cjqList
          this.tableDataH = data[0].cjhList
          this.getnumScore()
        })
      })
      this.numScore = [0]
      if (this.ksObj.jgfs && this.ksObj.jgfs < this.ksObj.zf) {
        this.numScore.push(this.ksObj.jgfs)
      }
      this.numScore.push(this.ksObj.zf)
    },
    changeType (type) {
      this.index = type
      this.chartSettings = { type: this.typeArr[this.index] }
    }
  },
  mounted () {
    this.changeType(0)
  }
}
</script>
